import { PipeTransform, Pipe } from '@angular/core';
import { BillingRequestModel } from '@app/models/Merchant-transaction-model/merchant-outletwise-txn-model';

@Pipe({
    name: 'billingfilter'
})
export class BillingFilterPipe implements PipeTransform {
    transform(items: BillingRequestModel[], searchTerm: string): BillingRequestModel[] {
        if (!items || !searchTerm) {
            return items;
        }
        return items.filter(item =>
            (item.PaymentDate.indexOf(searchTerm) !== -1)||
            (item.TerminalId.indexOf(searchTerm) !== -1)||
            (item.SettlementDate.indexOf(searchTerm) !== -1)||
            (item.Issuer.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)||
            (item.PAN.indexOf(searchTerm) !== -1)||
            (item.TransactionDate.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)||
            (item.TransactionType.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)||
            (item.Amount.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)||
            (item.Status.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)||
            (item.NetAmount.indexOf(searchTerm) != -1)||
            (item.DiscountAmount.indexOf(searchTerm) != -1)
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/billingRequestFilter.pipe.ts